import styled from "styled-components/macro";

export const DocumentTypeField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
`;

export const DocumentTypeLabel = styled.label`
  margin: 0;
  color: #6d6d6d;
  font-size: 14px;
  font-weight: 600;
`;
